/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignCreatorListResponseSchema,
  campaignPlatformSchema,
} from '../campaign-schema';

export const listCampaignCreatorsPathSchema = z.object({
  campaignId: z.string(),
});

export const listCampaignCreatorsQuerySchema = z.object({
  platform: campaignPlatformSchema.optional(),
  name: z.string().optional(),
  label: z.string().optional(),
  page: z.number().int().default(1),
  limit: z.number().int().default(20),
});

export const listCampaignCreatorsOperationResponseSchema =
  campaignCreatorListResponseSchema;

export type ListCampaignCreatorsInput = {
  path: z.input<typeof listCampaignCreatorsPathSchema>;
  query?: z.input<typeof listCampaignCreatorsQuerySchema>;
  signal?: AbortSignal;
};

export async function listCampaignCreators({
  path,
  query,
  signal,
}: ListCampaignCreatorsInput): Promise<
  z.infer<typeof listCampaignCreatorsOperationResponseSchema>
> {
  const parsedPath = listCampaignCreatorsPathSchema.parse(path);
  const parsedQuery = listCampaignCreatorsQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/creators`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listCampaignCreatorsOperationResponseSchema.parse(
    await response.json(),
  );
}
